module.exports = __webpack_public_path__ + "static/img/zhangxinyuan.ddfbdbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/zhangxinyuan.png
// module id = bUMZ
// module chunks = 0